export default function HowItWorks() {
  const steps = [
    { num: '01', title: 'Find Products', desc: 'Browse the Vigorbuy Spreadsheet categories to discover products that match your style and needs.' },
    { num: '02', title: 'Compare Options', desc: 'Use the Vigorbuy Spreadsheet comparison tools to evaluate products side by side.' },
    { num: '03', title: 'Review QC Photos', desc: 'Check real quality control photos in the Vigorbuy Spreadsheet to verify product quality.' },
    { num: '04', title: 'Complete Purchase', desc: 'Once you have made your decision, head to the main website to complete your purchase securely.' },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 text-center mb-3">
          How Vigorbuy Spreadsheet Works
        </h2>
        <p className="text-sm md:text-base text-foreground-600 text-center mb-10 max-w-xl mx-auto">
          Getting started with the Vigorbuy Spreadsheet is easy. Follow these four simple steps.
        </p>

        <div className="relative">
          <div className="hidden md:block absolute top-1/2 left-[12.5%] right-[12.5%] h-0.5 bg-background-200 -translate-y-1/2"></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-5 md:gap-3">
            {steps.map((step, i) => (
              <div key={step.num} className="relative text-center">
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-accent-500 text-background-50 text-lg font-heading font-semibold mx-auto mb-4 relative z-10">
                  {step.num}
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">{step.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed px-2">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}